import React, { useCallback, useEffect, useState } from 'react';
import { Body, Modal } from 'src/@vymo/ui/blocks';
import ImageToolContent from './imageToolContent';
import styles from './index.module.scss';

function ImageTool({
  imageData,
  aspectRatioList = ['custom', '1:1', '4:3'],
  onChange,
  disableCrop,
  modal,
  classNames = '',
  canZoom = false,
}) {
  const [showModal, setShowModal] = useState(true);

  useEffect(() => {
    setShowModal(true);
  }, [imageData]);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);
  return modal ? (
    <Modal
      open={showModal}
      showCloseButton={false}
      onClose={closeModal}
      classNames={styles.cropImage}
    >
      <Body>
        <ImageToolContent
          disableCrop={disableCrop}
          imageData={imageData}
          aspectRatioList={aspectRatioList}
          onChange={onChange}
          classNames={classNames}
          canZoom={canZoom}
        />
      </Body>
    </Modal>
  ) : (
    <ImageToolContent
      disableCrop={disableCrop}
      imageData={imageData}
      aspectRatioList={aspectRatioList}
      onChange={onChange}
      classNames={classNames}
      canZoom={canZoom}
    />
  );
}

export default ImageTool;
